<script lang="ts">
  import { pop } from "svelte-spa-router";
  import { Ver } from "$components";
  import ListNavigationItem from "$shared/components/ListNavigationItem.svelte";
  import Separator from "$shared/../shared/components/Separator.svelte";
  import CardInline from "$shared/components/CardInline.svelte";
  import { ModalDialog } from "$components";
  import CustomButton from "$shared/components/CustomButton.svelte";
  import ValInputField from "$shared/components/ValInputField.svelte";
  import { Form, Validate } from "$shared/lib/validation_next";
  import type {
    AgreementSpot,
    MyPagesSite,
    SpotShare,
  } from "$apis/parkito2";
  import { formatDate } from "$shared/utils/dateTime";
  import { myPages } from "../stores/myPagesData.svelte.ts";

  type Props = { params: { id?: string } };
  const { params }: Props = $props();

  const myPagesData = $derived($myPages.call.data);
  let showAccessSharingDialog: boolean = $state(false);

  const selectedSiteId = $derived(
    params?.id ?? myPagesData?.sites?.[0]?.id,
  );
  const site: MyPagesSite | undefined = $derived(
    myPagesData?.findSite(selectedSiteId),
  );
  const spots: AgreementSpot[] | undefined = $derived(
    myPagesData?.getAgreementsForSite(selectedSiteId).flatMap((a) =>
      a.agreement.spots
    ),
  );
  const spotShares: SpotShare[] | undefined = $derived(
    myPagesData?.getSpotSharesForSite(selectedSiteId),
  );

  const fieldSpot = Form.field(Validate.required());
  const fieldEmail = Form.field(Validate.required());

  const toggleAccessSharingDialog = () => {
    showAccessSharingDialog = !showAccessSharingDialog;
  };
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      onclick={pop}
      class="-ml-[8px] min-[480px]:hidden"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      {site?.name ?? "-"}
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="w-full min-[840px]:columns-2 columns-1 p-[24px] max-mobile:px-[8px]"
  >
    {#if !myPagesData?.siteHasActiveAgreements(selectedSiteId ?? "")}
      <CardInline title="Inga aktiva avtal i anläggning {site?.name ?? '-'}">
        <p class="px-[16px]">
          Hej! För att kunna se ytterligare information denna anläggningen krävs
          det att du har ett aktivt avtal.
        </p>
        <p class="px-[16px] py-[8px]">
          Under <b>Avtal</b> kan du se alla dina avtal och information om något
          behöver besvaras av dig. Om du har frågor eller funderingar är du
          välkommen att kontakta oss.
        </p>
      </CardInline>
    {:else}
      {#if spots && spots.length > 0}
        <CardInline title="Platser">
          <Ver gap="none">
            {#each spots as spot}
              {@const agreement = myPagesData.findAgreementBySpot(spot.id)}
              <ListNavigationItem
                title={spot.name}
                description={`Plats ${spot.numericName}`}
                labelRight={agreement?.agreement?.translateProductKind?.()}
                link={`#/site/${site?.id}/spot/${spot.id}`}
                isFirst={spot === spots[0]}
                isLast={spot === spots[spots.length - 1]}
              />
            {/each}
          </Ver>
        </CardInline>
      {/if}

      {#if spotShares && spotShares.length > 0}
        <CardInline title="Platsdelningar">
          <div>
            {#each spotShares as spotShare}
              <ListNavigationItem
                title={spotShare.spot.name}
                description={`Plats ${spotShare.spot.numeric_name}`}
                labelRight={spotShare.validUntil
                  ? `Giltig tom. ${
                    formatDate(spotShare.validUntil, "YYYY-MM-DD")
                  }`
                  : "Gäller tills vidare"}
                link={`#/site/${site?.id}/shared-spot/${spotShare.spot.id}`}
                isFirst={spotShare === spotShares[0]}
                isLast={spotShare === spotShares[spotShares.length - 1]}
              />
            {/each}
          </div>
        </CardInline>
      {/if}
    {/if}
    <!--
    <CardInline title="Laddning">
      <img
        src="./graphics/charging.svg"
        alt="digital-keys"
        class="mx-auto pt-[8px] pb-[32px]"
      />
      <ListNavigationItem
        title="Laddstation 43"
        description="Avtal aktivt"
        link="#/site/00000030-0000-0000-0000-0020302302320/charging/00230-030213-000"
        isFirst={true}
        isLast={true}
      />
    </CardInline>

    <CardInline
      title="Platsdelning (digitala nycklar)"
      buttonTitle="Skapa ny"
      buttonClick={toggleAccessSharingDialog}
    >
      <img src="./graphics/keys.svg" alt="digital-keys" class="mx-auto" />
      <p class="text-[#58686A] px-[16px] py-[16px]">
        Låna ut din plats genom att dela en digital nyckel till någon du känner.
      </p>
      <ListNavigationItem
        title="test@parkando.se"
        description="Giltig tills 2024-12-01"
        link="#/site/00000030-0000-0000-0000-0020302302320/sharing/00230-03021199-43930120"
        isFirst={true}
      />
      <ListNavigationItem
        title="19830108-5591"
        description="Giltig tills 2025-06-01"
        link="#/site/00000030-0000-0000-0000-0020302302320/sharing/00230-03021199-43930121"
        isLast={true}
      />
    </CardInline>
    -->
  </div>

  <!-- Add sccess sharing modal dialog -->
  {#if showAccessSharingDialog}
    <ModalDialog onBackdropPressed={toggleAccessSharingDialog}>
      <div class="px-[24px] py-[24px] max-mobile:px-[16px]">
        <h2 class="text-[#181818] text-[18px]">Skapa ny platsdelning</h2>
      </div>
      <Separator />
      <div class="px-[24px] py-[16px] max-mobile:px-[16px]">
        <form id="sharing-form">
          <ValInputField
            field={fieldSpot}
            name="spot"
            label="Plats"
            placeholder={"Plats"}
            customClass="py-[8px]"
          />
          <ValInputField
            field={fieldEmail}
            name="email"
            label="E-post"
            placeholder={"E-post"}
            customClass="py-[8px]"
          />
        </form>
        <div class="flex pt-[24px] justify-end">
          <CustomButton
            type="ghost"
            onClick={toggleAccessSharingDialog}
            customClass="mr-[8px]"
          >Avbryt</CustomButton>
          <CustomButton
            type="primary"
            onClick={() => {
              if (import.meta.env.DEV) {
                console.log("save-new-access-sharing-clicked");
              }
            }}
            customClass="w-[200px]"
          >Spara</CustomButton>
        </div>
      </div>
    </ModalDialog>
  {/if}
</div>
